import { Component } from '@angular/core';
import { EntitySelectorComponent } from '@app/selection/entity-selector.component';
import { Location } from '@app/_models/_DTOs/location';
import { DepartmentService } from '@app/_services/department.service';
import { LocationService } from '@app/_services/location.service';

@Component({
    selector: 'app-location-selector',
    templateUrl: './location-selector.component.html',
    styleUrls: ['./location-selector.component.css']
})
export class LocationSelectorComponent extends EntitySelectorComponent<Location> {


    constructor(
        private locationService: LocationService
    ) {
        super(locationService);
    }
}